import { Component, Input, OnInit } from '@angular/core';
import { MEDDICScores } from '@vendasta/sales-opportunities';
import { isFailed$, WorkStates } from '@vendasta/rx-utils/work-state';
import { Observable } from 'rxjs';

@Component({
  selector: 'sales-ui-meddic-title',
  templateUrl: './m-e-d-d-i-c-title.component.html',
  styleUrls: ['./m-e-d-d-i-c-title.component.scss'],
})
export class MEDDICTitleComponent implements OnInit {
  @Input() scoresState: WorkStates<MEDDICScores>;
  @Input() scoresKey: string;
  @Input() scoreI18nKey: string;
  isFailed$: Observable<boolean>;

  ngOnInit(): void {
    this.isFailed$ = isFailed$(this.scoresState);
  }
}
